export const ICON_FOLDER = 'folder';

export const ICON_INBOX = 'inbox';
